import React, { FC } from 'react';
import {
  StyledEventProfileSkeletonLoader,
  InputPlaceLoader,
  TextPlaceLoader,
} from './EventProfileSkeletonLoader.styles';
import { StyledEventProfileForm, StyledDivider, StyledCtaContainer } from '../EventProfile.styles';
import { StyledEventInfo } from '../../../molecules/EventInfo/EventInfo.styles';
import { StyledAttachments } from '../../../molecules/Attachments/Attachments.styles';

export const EventProfileSkeletonLoader: FC = () => {
  return (
    <StyledEventProfileSkeletonLoader className="container pt-0">
      <StyledEventProfileForm>
        <StyledEventInfo>
          <div className="row">
            <div className="col-md-12 pb-5">
              <InputPlaceLoader className="skeleton-loader mb-2" width="100%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 pb-5">
              <InputPlaceLoader className="skeleton-loader mb-2" width="100%" />
            </div>
            <div className="col-md-6 pb-5">
              <InputPlaceLoader className="skeleton-loader mb-2" width="100%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 pb-5">
              <InputPlaceLoader className="skeleton-loader mb-2" width="100%" />
            </div>
            <div className="col-md-6 pb-5">
              <InputPlaceLoader className="skeleton-loader mb-2" width="100%" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <InputPlaceLoader className="skeleton-loader mb-2" width="100%" />
            </div>
            <div className="col-md-6">
              <InputPlaceLoader className="skeleton-loader mb-2" width="100%" />
            </div>
          </div>
        </StyledEventInfo>
        <StyledDivider />
        <StyledAttachments>
          <div>
            <TextPlaceLoader className="skeleton-loader col-md-6 m-0 t-font-s" />
            <TextPlaceLoader className="skeleton-loader col-md-6 m-0 t-font-s" />
            <TextPlaceLoader className="skeleton-loader col-md-3 mt-3 t-font-s" />
          </div>
          <div className="my-4">
            <TextPlaceLoader className="skeleton-loader col-md-4 pt-4 pb-4 m-0 t-font-s" />
          </div>
        </StyledAttachments>
      </StyledEventProfileForm>
      <StyledCtaContainer>
        <TextPlaceLoader className="skeleton-loader pt-4 pb-4 m-0 t-font-s" width="10%" />
      </StyledCtaContainer>
    </StyledEventProfileSkeletonLoader>
  );
};
